import React from 'react';
import EmailIcon from '@mui/icons-material/Email';
import GitHubIcon from '@mui/icons-material/GitHub';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import YouTubeIcon from '@mui/icons-material/YouTube';
import FacebookIcon from '@mui/icons-material/Facebook';
import XIcon from '@mui/icons-material/X';
import { Box, Link, Typography } from '@mui/material';

interface SocialNetworkLabelProps {
    handle: string;
    name: string;
}
const getProfileLink = (platform: string, handle: string): string => {
    switch (platform.toLowerCase()) {
    case 'youtube':
        return `https://www.youtube.com/user/${handle}`;
    case 'instagram':
        return `https://www.instagram.com/${handle}`;
    case 'linkedin':
        return `https://www.linkedin.com/in/${handle}`;
    case 'github':
        return `https://github.com/${handle}`;
    case 'email':
        return `mailto:${handle}`;
    case 'facebook':
        return `https://www.facebook.com/${handle}`;
    case 'x':
        return `https://twitter.com/${handle}`;
    default:
        return '';
    }
};

const getIcon = (platform: string) => {
    switch (platform.toLowerCase()) {
    case 'youtube':
        return <YouTubeIcon/>;
    case 'instagram':
        return <InstagramIcon/>;
    case 'linkedin':
        return <LinkedInIcon/>;
    case 'github':
        return <GitHubIcon/>;
    case 'email':
        return <EmailIcon/>;
    case 'facebook':
        return <FacebookIcon/>;
    case 'x':
        return <XIcon/>;
    default:
        return null;
    }
};

const SocialNetworkLabel = ({ handle, name }: SocialNetworkLabelProps) => {
    const icon = getIcon(name);
    const profileLink = getProfileLink(name, handle);
    return (
        <Box>
            {handle && name ? (
                <Box display={'flex'} alignItems={'center'}>
                    {icon ? (
                        <Box mr={1} my={.5} display={'flex'} alignItems={'center'}>
                            {icon}
                        </Box>
                    ) : (
                        <Box mr={1} my={.5}>
                            <Typography sx={{
                                fontWeight: 'bold'
                            }}
                            >
                                {`${name}`}
                            </Typography>
                        </Box>
                    )}
                    <Box my={.5}>
                        {profileLink ? (
                            <Link href={profileLink} target='_blank' rel='noopener'>
                                {handle}
                            </Link>
                        ) : (
                            <Typography variant={'body1'}>{handle}</Typography>
                        )}
                    </Box>
                </Box>
            ) : null}
        </Box>
    );
};

export default SocialNetworkLabel;
